import { ActivityIndicator, Header, MCIcon } from "@src/components"
import { ar } from "@src/i18n"
import { DeliveryAreasView } from "@src/components/delivery-area"
import { Pressable } from "react-native"
import { trpc } from "@src/utils"

export default function DeliveryAreas() {
  const list = trpc.deliveryAreas.list.useQuery()

  async function handlePress() {
    await list.refetch()
  }

  const header = (
    <Header
      title={ar.deliveryAreas}
      right={
        <Pressable className="h-full justify-center items-center px-2" onPress={handlePress} disabled={list.isPending || list.isFetching}>
          <MCIcon name="refresh" size={25} className={list.isFetching ? "animate-spin" : ""} />
        </Pressable>
      }
    />
  )

  if (list.isLoading) {
    return (
      <>
        {header}
        <ActivityIndicator className="mt-4" />
      </>
    )
  }

  return (
    <>
      {header}
      <DeliveryAreasView />
    </>
  )
}
